import {
    NEWS_CREATE,
    NEWS_CREATE_PAGE_LOADED,
    NEWS_CREATE_PAGE_UNLOADED,
    NEWS_UPDATE,
    NEWS_UPDATE_PAGE_UNLOADED,
    NEWS_LIST_PAGE_LOADED,
    NEWS_LIST_PAGE_UNLOADED,
    NEWS_DETAIL_PAGE_LOADED,
    NEWS_DETAIL_PAGE_UNLOADED,
    NEWS_DELETE
} from '../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case NEWS_CREATE:
        case NEWS_UPDATE:
        case NEWS_DELETE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
            };
        case NEWS_DETAIL_PAGE_LOADED:
            return {
                ...state,
                news: action.error ? null : action.payload.news,
            }
        case NEWS_LIST_PAGE_LOADED:
            return {
                ...state,
                news_list: action.error ? null : action.payload.news,
            }
        case NEWS_CREATE_PAGE_UNLOADED:
        case NEWS_UPDATE_PAGE_UNLOADED:
        case NEWS_LIST_PAGE_UNLOADED:
        case NEWS_DETAIL_PAGE_UNLOADED:
            return {};
        default:
            return state;
    }
};
